<template>
  <div v-if="t">
    <table
      v-if="usages.length"
      class="table is-narrow is-fullwidth is-striped-v">
      <thead class="has-cells-vcentered">
        <tr class="is-size-6">
          <th class="has-text-centered"></th>
          <th>Date</th>
          <th>Élément</th>
          <th>Rôle</th>
          <th>Interlocuteur</th>
          <th>Utilisateur</th>
        </tr>
      </thead>
      <tbody class="has-cells-vcentered">
        <tr
          v-for="(usage, i) in usages"
          :key="usage.pk"
          class="is-size-6">
          <td class="has-text-centered">
            <avatar
              v-if="interlocuteurFor(usage)"
              :item="interlocuteurFor(usage)"
              :i="i" />
            <span
              v-else
              class="icon is-medium has-text-grey">
              <i
                class="fal fa-lg"
                :class="usage.entity_type === 'Programme' ? 'fa-city' : 'fa-file-signature'"></i>
            </span>
          </td>
          <td class="is-nowrap">
            {{ usage.date | date }}
          </td>
          <td :class="{'is-cell-hoverable': usageRoute(usage)}">
            <router-link
              v-if="usageRoute(usage)"
              :to="usageRoute(usage)"
              class="fullLink">
              <b>{{ usage.entity_type }} {{ usage.entity_ref }}</b>
              <span
                v-if="usage.program_name"
                class="has-text-grey">&nbsp;— {{ usage.program_name }}</span>
            </router-link>
            <template v-else>
              <b>{{ usage.entity_type }} {{ usage.entity_ref }}</b>
              <span
                v-if="usage.program_name"
                class="has-text-grey">&nbsp;— {{ usage.program_name }}</span>
            </template>
          </td>
          <td>
            <span v-if="usage.role">{{ usage.role }}</span>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="interlocuteurName(usage.interlocuteur_id)">{{ interlocuteurName(usage.interlocuteur_id) }}</span>
            <span v-else>-</span>
          </td>
          <td>
            <span v-if="usage.user_name">{{ usage.user_name }}</span>
            <span v-else>-</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div
      v-else
      class="is-padding">
      <h2 class="title is-5">
        Aucune utilisation enregistrée
      </h2>
      <p class="is-size-6 has-text-grey">
        L'historique se remplit automatiquement quand ce tiers est sélectionné dans une réservation, un programme...
      </p>
    </div>
  </div>
</template>

<script>
import TiersMixin from '../TiersMixin'

export default {
  name: 'TiersHistory',
  mixins: [TiersMixin],
  computed: {
    usages () {
      return [...(this.t.usages || [])].sort((a, b) => (a.date < b.date ? 1 : -1))
    }
  },
  methods: {
    /**
     * Route de l'entité utilisatrice — null si non navigable
     * @param {object} usage
     * @returns {object|null}
     */
    usageRoute (usage) {
      if (!usage.entity_pk) return null
      if (usage.entity_type === 'Réservation' || usage.entity_type === 'Pré-réservation') {
        return { name: 'AdvInfos', params: { id: usage.entity_pk } }
      }
      if (usage.entity_type === 'Programme') {
        return { name: 'ProgramEdit', params: { id: usage.entity_pk } }
      }
      if (usage.entity_type === 'Lot') {
        return { name: 'LotEdit', params: { id: usage.entity_pk } }
      }
      return null
    },
    /**
     * @param {object} usage
     * @returns {object|undefined}
     */
    interlocuteurFor (usage) {
      return (this.t.interlocuteurs || []).find(i => i.pk === usage.interlocuteur_id)
    },
    /**
     * @param {string} pk
     * @returns {string|null}
     */
    interlocuteurName (pk) {
      const interlocuteur = (this.t.interlocuteurs || []).find(i => i.pk === pk)
      if (!interlocuteur) return null
      return `${(interlocuteur.last_name || '').toUpperCase()} ${interlocuteur.first_name || ''}`.trim()
    }
  }
}
</script>
